import createApi from "../utils/apiClient";
const api = createApi();

// ── Buses ──
export const getBuses = () => async (dispatch) => {
  try {
    dispatch({ type: "TRANSPORT_REQUEST" });
    const { data } = await api.get("/transport/buses");
    dispatch({ type: "GET_BUSES_SUCCESS", payload: data.buses });
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const createBus = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/buses", payload);
    dispatch(getBuses());
    return data;
  } catch (err) {
    throw err;
  }
};

export const updateBus = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.put(`/transport/buses/${id}`, payload);
    dispatch(getBuses());
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteBus = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/transport/buses/${id}`);
    dispatch(getBuses());
    return data;
  } catch (err) {
    throw err;
  }
};

// ── Routes ──
export const getRoutes = () => async (dispatch) => {
  try {
    dispatch({ type: "TRANSPORT_REQUEST" });
    const { data } = await api.get("/transport/routes");
    dispatch({ type: "GET_ROUTES_SUCCESS", payload: data.routes || data });
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const createRoute = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/routes", payload);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const updateRoute = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.put(`/transport/routes/${id}`, payload);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteRoute = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/transport/routes/${id}`, {
      data: payload || {},
    });
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const getBusStops = (routeId) => async (dispatch) => {
  try {
    const { data } = await api.get(`/transport/routes/${routeId}/stops`);
    dispatch({ type: "STOPS_SUCCESS", payload: data.stops });
    return data.stops;
  } catch (err) {}
};

// ── Stops ──
export const createStop = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/stops", payload);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const updateStop = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.put(`/transport/stops/${id}`, payload);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteStop = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/transport/stops/${id}`);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

// ── Student assignment ──
export const assignTransport = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/assign", payload);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const removeStudentAssignment = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/transport/assign/${id}`, {
      data: { reason },
    });
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

// ── Staff assignment ──
export const assignStaffTransport = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/assign-staff", payload);
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

export const removeStaffAssignment = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/transport/assign-staff/${id}`, {
      data: { reason },
    });
    dispatch(getRoutes());
    return data;
  } catch (err) {
    throw err;
  }
};

// ── Self view (student / staff) ──
export const getMyTransport = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/my", { params });
    dispatch({ type: "MY_TRANSPORT_SUCCESS", payload: data.transport });
    return data.transport;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const getTransportHistory = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/history", { params });
    dispatch({ type: "TRANSPORT_HISTORY_SUCCESS", payload: data.history });
    return data.history;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const getStaffAssignmentHistory = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/staff-history", { params });
    dispatch({
      type: "STAFF_ASSIGNMENT_HISTORY_SUCCESS",
      payload: data.history,
    });
    return data.history;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

// ── Daily bus boarding attendance ──
export const getAttendanceRoster = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/attendance/roster", { params });
    dispatch({ type: "ATTENDANCE_ROSTER_SUCCESS", payload: data.roster });
    return data.roster;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const markAttendance = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/attendance", payload);
    return data;
  } catch (err) {
    throw err;
  }
};

export const getAttendanceHistory = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/attendance/history", { params });
    return data.history;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const getTransportAttendanceSummary = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/attendance/summary", { params });
    return data;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

// ── Parent (multiple children) ──
export const getMyChildrenTransport = () => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/my-children");
    dispatch({ type: "MY_CHILDREN_TRANSPORT_SUCCESS", payload: data.children });
    return data.children;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

// ── Daily logs ──
export const getDailyLogs = (params) => async (dispatch) => {
  try {
    const { data } = await api.get("/transport/daily-logs", { params });
    dispatch({ type: "DAILY_LOGS_SUCCESS", payload: data.logs });
    return data.logs;
  } catch (err) {
    dispatch({ type: "TRANSPORT_FAIL", payload: err.response?.data?.message });
  }
};

export const upsertDailyLog = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post("/transport/daily-logs", payload);
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteDailyLog = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/transport/daily-logs/${id}`);
    return data;
  } catch (err) {
    throw err;
  }
};
